import {Component, Injector, OnInit} from '@angular/core';
import { Base } from '../../pages/base/base';
import {Router} from '@angular/router';


@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent extends Base {

  constructor(injector: Injector,
              private router: Router) {
    super(injector);
    if (!this.GetUser()) {
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/documents']);
    }
  }
}
